import { useEffect } from 'react';
import useSimulationStore from '../store/simulationStore';

const useSimulation = () => {
  // Fetch resetSimulation action from the store
  const resetSimulation = useSimulationStore((state) => state.resetSimulation);

  // Effect for triggering INITIAL simulation reset on mount
  useEffect(() => {
    console.log('useSimulation mount effect: triggering resetSimulation.');
    resetSimulation();
  // Run only once on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []); 

  // The hook itself doesn't need to return particles/isRunning anymore,
  // components should select those directly from the store.
  // return {}; // Or return nothing
};

export default useSimulation; 